import { adminHttpClient } from '../../commons/adminHttpClient'
import { ProductEligibleEmployee } from 'domain/benefit/productEligibleEmployee'
import OrderedPageFilter from 'application/commons/orderedPageFilter'

export interface PagedProductEligibleEmployee {
  items: ProductEligibleEmployee[]
  totalItemCount: number
  pageCount: number
  pageNumber: number
  pageSize: number
}

const getProductEligibleEmployeesApi = (
  filter: OrderedPageFilter,
  productClassId: string | undefined,
): Promise<PagedProductEligibleEmployee> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'id',
    orderDescending: false,
  }

  return adminHttpClient.get('/csi/companies/benefit/producteligibleemployees', {
    ...filter,
    productClassId: productClassId,
  })
}

export default getProductEligibleEmployeesApi
